function errorHandling(error, errorMessages): string {
  let message;

  if (!!error && !!error.status && !!errorMessages[error.status]) {
    message = errorMessages[error.status];
  } else {
    message = errorMessages.default || '';
  }

  return message;
}

export { errorHandling };
